import React from "react";
import { CustomViewPickerRender } from "../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch";
import { Client, ClientPatch } from "../../types/clients.types";

import { ResponseAPIWithPagination } from "../../../../utils/genericAPI/API.types";
import { clientAPI } from "../../services/clientsAPI";

import MicroPicker from "../../../../common/components/organisme/MicroSelectorGeneric/MicroSelectorGeneric";

export interface ClientPickerProps {
  currentClient?: Client;
  setClient: (client: Client | undefined) => void;
  clientId?: string;
  style?: React.CSSProperties;
  customViewRender?: CustomViewPickerRender;
  label?: string;
  createDefaultItem?: (value: string) => ClientPatch;
  placeHolder?: string;
  searchPlaceholder?: string;
  textFormat?: (client: Client | undefined) => string;
  isError?: boolean;
}

export default function ClientPicker({
  currentClient,
  setClient,
  customViewRender,
  textFormat,
  placeHolder = "Sélectionner un client",
  searchPlaceholder = "Rechercher un client",
  isError,
  style,
  label,
  createDefaultItem: createDefaultItemRaw,
}: ClientPickerProps) {
  const getTextClientDefault = (client: Client | undefined) => {
    if (!client || null) return "";
    if (textFormat) return textFormat(client);
    return (
      client.client_firstname +
      " " +
      client.client_lastname +
      " - " +
      client.client_email
    );
  };
  return (
    <MicroPicker
      label={label}
      style={style}
      setElement={setClient}
      currentElement={currentClient}
      createDefaultItem={createDefaultItemRaw}
      placeHolder={placeHolder}
      searchPlaceholder={searchPlaceholder}
      customViewRender={customViewRender}
      iconTypeResultElement="profil"
      SearchFn={(query, page, pageSize) =>
        clientAPI.getAll({ search: query, page, pageSize })
      }
      textFormatValue={textFormat || getTextClientDefault}
      convertResult={(result) => {
        result as ResponseAPIWithPagination<Client>;
        return result?.data?.map((item: Client) => ({
          id: item.client_id,
          name: getTextClientDefault(item),
          item,
        }));
      }}
      addMoreResult={(prev, next) => {
        prev as ResponseAPIWithPagination<Client>;
        next as ResponseAPIWithPagination<Client>;
        if (!prev?.data || !next?.data) return prev;

        return {
          ...next.data,
          data: [...prev.data, ...next.data],
        };
      }}
      extractLastPageNb={(result) => {
        result as ResponseAPIWithPagination<Client>;
        return result.pagination.total_pages;
      }}
    />
  );
}
